import angular from 'angular';

const dashboardActionsfactory = function DashboardActionsfactory($log, endPoints, NewBackendService, Dispatcher, StoreStates, NewUiService) {
    'ngInject';
    const actionsObject = {
      getDashboardData: function(days) {
        const daysFilter = NewUiService.checkSocialProvisionsDaysFilter(days);

        Dispatcher.dispatch({
          actionType: 'DASHBOARD_LOAD_START',
          data: {
            days: daysFilter
          },
          state: StoreStates.STORE_PENDING_UPDATE
        });

        NewBackendService.invokeWebApiPost('wallet/getDashboardResult', {
          'userContext': {},
          'data': {
            'dtoReq': {
              'dtoGetDashboardResultReq': {
                'numberOfDays': daysFilter
              }
            }
          }
        }, true).then(function(result) {
          Dispatcher.dispatch({
            actionType: 'DASHBOARD_LOAD',
            data: {
              dashboardData: result.data.dtoRes.dtoGetDashboardResultRes,
              days: daysFilter
            },
            state: StoreStates.STORE_VALID
          });
        }, function(reason) {
          Dispatcher.dispatch({
            actionType: 'DASHBOARD_LOAD_FAIL',
            data: {
              reason,
              days: daysFilter
            },
            state: StoreStates.STORE_FAILED_UPDATE
          });
        });
      },
      getChartData: function(days) {
        const daysFilter = NewUiService.checkSocialProvisionsDaysFilter(days);

        Dispatcher.dispatch({
          actionType: 'DASHBOARDCHART_LOAD_START',
          state: StoreStates.STORE_PENDING_UPDATE,
          data: {
            days: daysFilter
          }
        });

        NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/wallet-transactions/balance-trend-track`, {}, true).then(function(result) {
          console.log(result)
          Dispatcher.dispatch({
            actionType: 'DASHBOARDCHART_LOAD',
            state: StoreStates.STORE_VALID,
            data: {
              days: daysFilter,
              chartData: result.data._embedded.historyBalanceTrendResourceList
            }
          });
        }, function(reason) {
          Dispatcher.dispatch({
            actionType: 'DASHBOARDCHART_LOAD_FAIL',
            state: StoreStates.STORE_FAILED_UPDATE,
            data: {
              days: daysFilter,
              reason
            }
          });
        });
      }
    };
    return actionsObject;
  }

export default dashboardActionsfactory ;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/dashboardActions.factory.js
 **/